import { InjectionToken } from "@angular/core";

export interface ExtractionStepsApiConfig {
	portalBackendUrl?: string;
	portalApiKey?: string;
}

export const EXTRACTION_STEPS_API_CONFIG = new InjectionToken<ExtractionStepsApiConfig>("EXTRACTION_STEPS_API_CONFIG");
